import { ELEMENT_EVENT } from "../types/constants";
import { SELECTOR } from "../types/element/constants";

let searchForm: HTMLFormElement | null = null;

function reset() {
  searchForm = null;
}

function init() {
  const parentWrapper: HTMLDivElement = document.querySelector(SELECTOR.SEARCH_CONTAINER) as HTMLDivElement;

  if (!searchForm && parentWrapper) {
    searchForm = parentWrapper.querySelector(SELECTOR.SEARCH_FORM) as HTMLFormElement;
    const suggestLayer: HTMLDivElement = parentWrapper.querySelector(SELECTOR.LAYER) as HTMLDivElement;
    const searchField: HTMLInputElement = parentWrapper.querySelector(SELECTOR.SEARCH_FIELD) as HTMLInputElement;

    /*                        */
    if (suggestLayer) {
      window.o_util.event.delegate(
        SELECTOR.LAYER,
        ELEMENT_EVENT.CLICK,
        SELECTOR.SUGGEST_TERM,
        window.o_squirrel.searchSuggest.onSuggestItemClick,
      );
      window.o_util.event.delegate(
        SELECTOR.LAYER,
        ELEMENT_EVENT.CLICK,
        SELECTOR.MODIFIED_ARROW,
        window.o_squirrel.searchSuggest.clickArrowAction,
      );
      window.o_util.event.delegate(
        SELECTOR.LAYER,
        ELEMENT_EVENT.CLICK,
        SELECTOR.HISTORY_EDIT_BUTTON,
        window.o_squirrel.searchHistory.clickEditAction,
      );
      window.o_util.event.delegate(
        SELECTOR.LAYER,
        ELEMENT_EVENT.CLICK,
        SELECTOR.HISTORY_CLASS,
        window.o_squirrel.searchHistory.clickTermAction,
      );
      window.o_util.event.delegate(
        SELECTOR.LAYER,
        ELEMENT_EVENT.CLICK,
        SELECTOR.HISTORY_DELETEALL,
        window.o_squirrel.searchHistory.clickDeleteAllAction,
      );

      window.o_squirrel.searchSuggest.init();
      window.o_squirrel.searchHistory.init();
      window.o_squirrel.emptyStateSuggest.init();

      searchField.addEventListener(ELEMENT_EVENT.INPUT, window.o_squirrel.searchSuggest.handleInput);
      searchField.onkeydown = window.o_squirrel.searchSuggest.handleKeyAction;
      searchField.addEventListener(ELEMENT_EVENT.CLICK, window.o_squirrel.searchSuggest.clickSearchFieldAction);
      searchField.addEventListener(ELEMENT_EVENT.FOCUS, window.o_squirrel.searchSuggest.focusSearchFieldAction);
      searchField.addEventListener(ELEMENT_EVENT.FOCUS_OUT, window.o_squirrel.searchSuggest.focusOutSearchFieldAction);
      window.addEventListener(ELEMENT_EVENT.BLUR, window.o_squirrel.searchSuggest.blurWindowAction);

      /*                                                                                                          */
      /*                                                                     */
      /*                                                                        */
      window.o_squirrel.searchSuggest.fetchSuggestions(searchField.value || "", 0, {
        headers: {
          "x-request-type": "init",
        },
      });
    }
  }
}

export const suggestLayer = {
  init,
  reset,
};
